import { createAsyncAction } from 'typesafe-actions';
import { BuildError, BuildLogsRequest, BuildLogsResponse } from './types';

export const buildLogs = createAsyncAction(
  'BUILD_LOGS_REQUEST',
  'BUILD_LOGS_SUCCESS',
  'BUILD_LOGS_ERROR',
)<BuildLogsRequest, BuildLogsResponse, BuildError>();
